const path = {
  registrationPage: '/register',
  logInPage: '/login',
  dashboardPage: '/home',
  statistic: '/diagram',
  currency: '/currency',
};

export default path;
